import React from "react";
import { Link } from "react-router-dom";

import { InvestorMetricIcon } from "./InvestorMetricIcons";

function IconPlus() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" aria-hidden>
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function MetricValue({ value }) {
  if (value && typeof value === "object" && value.type === "money") {
    const title = `${value.sign || ""}৳ ${value.amount}`;
    return (
      <div className="investor-metric-card__value" title={title}>
        {value.sign ? <span className="investor-metric-card__sign">{value.sign}</span> : null}
        <span className="investor-metric-card__currency" aria-hidden="true">
          ৳
        </span>
        <span className="investor-metric-card__digits">{value.amount}</span>
      </div>
    );
  }

  return <div className="investor-metric-card__value">{value}</div>;
}

function MetricCard({ m }) {
  const accent = m.accent || (m.tone === "profit" ? "green" : m.tone === "loss" ? "red" : "blue");
  const isFeatured = Boolean(m.featured);

  return (
    <div
      className={[
        "investor-metric-card",
        `investor-metric-card--${accent}`,
        isFeatured ? "investor-metric-card--featured" : "",
        m.tone === "profit" ? "investor-metric-card--profit" : "",
        m.tone === "loss" ? "investor-metric-card--loss" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      {isFeatured ? (
        <>
          <div className="investor-metric-card__label">{m.label}</div>
          <MetricValue value={m.value} />
          {m.hint ? <div className="investor-metric-card__hint">{m.hint}</div> : null}
          <div className="investor-metric-card__actions" role="group" aria-label="Wallet actions">
            <Link to="/wallet?deposit=1" className="investor-metric-card__btn investor-metric-card__btn--primary">
              <IconPlus />
              Add Funds
            </Link>
            <Link to="/wallet?withdraw=1" className="investor-metric-card__btn investor-metric-card__btn--secondary">
              Withdraw
            </Link>
          </div>
        </>
      ) : (
        <>
          <div className="investor-metric-card__top">
            <div className="investor-metric-card__label">{m.label}</div>
            {m.icon ? (
              <span className="investor-metric-card__icon" aria-hidden>
                <InvestorMetricIcon name={m.icon} />
              </span>
            ) : null}
          </div>
          <MetricValue value={m.value} />
          {m.hint ? <div className="investor-metric-card__hint">{m.hint}</div> : null}
        </>
      )}
    </div>
  );
}

export default function InvestorMetricGrid({ metrics = [] }) {
  if (!metrics.length) return null;

  const featured = metrics.filter((m) => m.featured);
  const row = metrics.filter((m) => !m.featured);

  return (
    <div className="investor-metric-stack" role="group" aria-label="Summary metrics">
      {featured.length ? (
        <div className="investor-metric-featured">
          {featured.map((m) => (
            <MetricCard key={m.key || m.label} m={m} />
          ))}
        </div>
      ) : null}
      {row.length ? (
        <div className="investor-metric-grid">
          {row.map((m) => (
            <MetricCard key={m.key || m.label} m={m} />
          ))}
        </div>
      ) : null}
    </div>
  );
}
